'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _strftime = require('strftime');

var _strftime2 = _interopRequireDefault(_strftime);

var _Logger = require('@/libs/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _BufferKey = require('./BufferKey');

var _BufferKey2 = _interopRequireDefault(_BufferKey);

var _MessageListMessageCompact = require('./MessageListMessageCompact');

var _MessageListMessageCompact2 = _interopRequireDefault(_MessageListMessageCompact);

var _MessageListMessageModern = require('./MessageListMessageModern');

var _MessageListMessageModern2 = _interopRequireDefault(_MessageListMessageModern);

var _MessageListMessageInline = require('./MessageListMessageInline');

var _MessageListMessageInline2 = _interopRequireDefault(_MessageListMessageInline);

var _LoadingAnimation = require('./LoadingAnimation.vue');

var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('@/libs/polyfill/Element.closest');

var log = _Logger2.default.namespace('MessageList.vue');

var BOTTOM_SCROLL_MARGIN = 30;

exports.default = {
    components: {
        BufferKey: _BufferKey2.default,
        MessageListMessageModern: _MessageListMessageModern2.default,
        MessageListMessageCompact: _MessageListMessageCompact2.default,
        MessageListMessageInline: _MessageListMessageInline2.default,
        LoadingAnimation: _LoadingAnimation2.default
    },
    props: ['buffer'],
    data: function data() {
        return {
            auto_scroll: true,
            chathistoryAvailable: true,
            hover_nick: '',
            message_info_open: null,
            timeToClose: false,
            startClosing: false,
            selectedMessages: new _set2.default()
        };
    },

    computed: {
        thisMl: function thisMl() {
            return this;
        },
        listType: function listType() {
            if (this.$state.setting('messageLayout')) {
                log.info('Deprecation Warning: The config option \'messageLayout\' has been moved to buffers.messageLayout');
            }
            return this.buffer.setting('messageLayout') || this.$state.setting('messageLayout');
        },
        useExtraFormatting: function useExtraFormatting() {
            return this.buffer.setting('extra_formatting');
        },
        shouldShowChathistoryTools: function shouldShowChathistoryTools() {
            if (this.buffer.getNetwork().state !== 'connected') {
                return false;
            }

            var isCorrectBufferType = this.buffer.isChannel() || this.buffer.isQuery();
            var isSupported = !!this.buffer.getNetwork().ircClient.chathistory.isSupported();
            return isCorrectBufferType && isSupported && this.buffer.flags.chathistory_available;
        },
        shouldRequestChannelKey: function shouldRequestChannelKey() {
            return this.buffer.getNetwork().state === 'connected' && this.buffer.isChannel() && this.buffer.flags.channel_badkey;
        },
        ourNick: function ourNick() {
            return this.buffer ? this.buffer.getNetwork().nick : '';
        },
        filteredMessages: function filteredMessages() {
            var network = this.buffer.getNetwork();
            var currentNick = network.nick;
            var bufferMessages = this.buffer.getMessages();

            var ignoredVar = this.buffer.message_count;

            var messages = bufferMessages.slice(0, bufferMessages.length);
            messages.sort(function (a, b) {
                if (a.time > b.time) {
                    return 1;
                } else if (b.time > a.time) {
                    return -1;
                }

                return 0;
            });

            var list = [];
            var maxSize = this.buffer.setting('scrollback_size');
            var showJoinParts = this.buffer.setting('show_joinparts');
            var showTopics = this.buffer.setting('show_topics');
            var showNickChanges = this.buffer.setting('show_nick_changes');
            var showModeChanges = this.buffer.setting('show_mode_changes');
            for (var i = messages.length - 1; i >= 0 && list.length < maxSize; i--) {
                if (!showJoinParts && messages[i].type === 'traffic') {
                    continue;
                }
                if (!showTopics && messages[i].type === 'topic') {
                    continue;
                }
                if (!showNickChanges && messages[i].type === 'nick') {
                    continue;
                }
                if (!showModeChanges && messages[i].type === 'mode') {
                    continue;
                }

                if (messages[i].ignore) {
                    continue;
                }

                if (messages[i].type === 'connection' && i === 0) {
                    continue;
                }

                if (messages[i].type === 'topic' && messages[i - 1] && messages[i - 1].type === 'traffic' && messages[i - 1].nick === currentNick) {
                    list.push(messages[i - 1]);
                    list.push(messages[i]);
                    i--;
                } else {
                    list.push(messages[i]);
                }
            }

            return list.reverse();
        },
        shouldShowJoiningLoader: function shouldShowJoiningLoader() {
            return this.buffer.isChannel() && this.buffer.enabled && !this.buffer.joined && this.buffer.getNetwork().state === 'connected';
        }
    },
    watch: {
        buffer: function buffer(newBuffer) {
            if (!newBuffer) {
                return;
            }

            this.message_info_open = null;

            if (this.buffer.getNetwork().state === 'connected') {
                newBuffer.flags.has_opened = true;
            }

            this.scrollToBottom();
        },
        'buffer.message_count': function bufferMessage_count() {
            var _this = this;

            this.$nextTick(function () {
                _this.maybeScrollToBottom();
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.addCopyListeners();

        this.$nextTick(function () {
            _this2.scrollToBottom();
        });

        this.listen(this.$state, 'mediaviewer.opened', function () {
            _this2.$nextTick(_this2.maybeScrollToBottom.apply(_this2));
        });

        this.listen(this.$state, 'messagelist.scrollto', function (opt) {
            if (opt && opt.id) {
                _this2.maybeScrollToId(opt.id);
            }
        });
    },

    methods: {
        isHoveringOverMessage: function isHoveringOverMessage(message) {
            return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
        },
        toggleMessageInfo: function toggleMessageInfo(message) {
            if (!message) {
                this.message_info_open = null;
            } else if (this.message_info_open === message) {} else if (this.canShowInfoForMessage(message)) {
                var sel = window.getSelection();
                if (sel.rangeCount > 0) {
                    var range = sel.getRangeAt(0);
                    if (range && !range.collapsed) {
                        return;
                    }
                }

                this.message_info_open = message;
                this.$nextTick(this.maybeScrollToBottom.bind(this));
            }
        },
        shouldShowUnreadMarker: function shouldShowUnreadMarker(idx) {
            var previous = this.filteredMessages[idx - 1];
            var current = this.filteredMessages[idx];
            var lastRead = this.buffer.last_read;

            if (!lastRead) {
                return false;
            }

            if (previous && previous.time < lastRead && current.time > lastRead) {
                return true;
            }

            return false;
        },
        shouldShowDateChangeMarker: function shouldShowDateChangeMarker(idx) {
            var previous = this.filteredMessages[idx - 1];
            var current = this.filteredMessages[idx];

            if (!previous) {
                return false;
            }

            if (new Date(previous.time).getDay() !== new Date(current.time).getDay()) {
                return true;
            }

            return false;
        },
        canShowInfoForMessage: function canShowInfoForMessage(message) {
            var showInfoForTypes = ['privmsg', 'notice', 'action'];
            return showInfoForTypes.indexOf(message.type) > -1;
        },
        bufferSetting: function bufferSetting(key) {
            return this.buffer.setting(key);
        },
        formatTime: function formatTime(time) {
            return (0, _strftime2.default)(this.buffer.setting('timestamp_format') || '%T', new Date(time));
        },
        formatTimeFull: function formatTimeFull(time) {
            var format = this.buffer.setting('timestamp_full_format');
            return format ? (0, _strftime2.default)(format, new Date(time)) : new Date(time).toLocaleString();
        },
        formatMessage: function formatMessage(message) {
            return message.toHtml(this);
        },
        isMessageHighlight: function isMessageHighlight(message) {
            if (message.type === 'traffic') {
                return false;
            }

            return message.isHighlight;
        },
        userColour: function userColour(user) {
            if (user && this.bufferSetting('colour_nicknames_in_messages')) {
                return user.getColour();
            }
            return '';
        },
        openUserBox: function openUserBox(nick) {
            var user = this.$state.getUser(this.buffer.networkid, nick);
            if (user) {
                this.$state.$emit('userbox.show', user, {
                    buffer: this.buffer
                });
            }
        },
        onListClick: function onListClick(event) {
            this.toggleMessageInfo();
        },
        onMessageDblClick: function onMessageDblClick(event, message) {
            clearTimeout(this.messageClickTmr);

            var userNick = event.target.getAttribute('data-nick');
            if (userNick) {
                this.$state.$emit('input.insertnick', userNick);
            }
        },
        onMessageClick: function onMessageClick(event, message, delay) {
            if (delay && event.target.getAttribute('data-nick')) {
                clearTimeout(this.messageClickTmr);
                this.messageClickTmr = setTimeout(this.onMessageClick, 200, event, message, false);
                return;
            }

            var isLink = event.target.tagName === 'A';

            var channelName = event.target.getAttribute('data-channel-name');
            if (channelName && isLink) {
                var network = this.buffer.getNetwork();
                this.$state.addBuffer(this.buffer.networkid, channelName);
                network.ircClient.join(channelName);
                this.$state.setActiveBuffer(this.buffer.networkid, channelName);
                return;
            }

            var userNick = event.target.getAttribute('data-nick');
            if (userNick && isLink) {
                this.openUserBox(userNick);
                return;
            }

            var url = event.target.getAttribute('data-url');
            if (url && isLink) {
                if (this.$state.setting('buffers.inline_link_previews')) {
                    message.embed.type = 'url';
                    message.embed.payload = url;
                } else {
                    this.$state.$emit('mediaviewer.show', url);
                }
            }

            if (this.message_info_open && this.message_info_open !== message) {
                this.toggleMessageInfo();
                event.preventDefault();
                return;
            }

            if (this.$state.ui.is_touch && this.$state.setting('buffers.show_message_info')) {
                if (this.canShowInfoForMessage(message) && event.target.nodeName === 'A') {
                    event.preventDefault();
                }

                this.toggleMessageInfo(message);
            }
        },
        onThreadScroll: function onThreadScroll() {
            var el = this.$el;
            var scrolledUpByPx = el.scrollHeight - (el.offsetHeight + el.scrollTop);

            if (scrolledUpByPx > BOTTOM_SCROLL_MARGIN) {
                this.auto_scroll = false;
            } else {
                this.auto_scroll = true;
            }
        },
        scrollToBottom: function scrollToBottom() {
            this.$el.scrollTop = this.$el.scrollHeight;
        },
        maybeScrollToBottom: function maybeScrollToBottom() {
            if (this.auto_scroll) {
                this.$el.scrollTop = this.$el.scrollHeight;
            }
        },
        maybeScrollToId: function maybeScrollToId(id) {
            var messageElement = this.$el.querySelector('.kiwi-messagelist-message[data-message-id="' + id + '"]');
            if (messageElement && messageElement.offsetTop) {
                this.$el.scrollTop = messageElement.offsetTop;
                this.auto_scroll = false;
            }
        },
        restrictTextSelection: function restrictTextSelection() {
            document.querySelector('body').classList.add('kiwi-unselectable');
            this.$el.style.userSelect = 'text';
        },
        unrestrictTextSelection: function unrestrictTextSelection() {
            document.querySelector('body').classList.remove('kiwi-unselectable');
            this.$el.style.userSelect = 'auto';
        },
        removeSelections: function removeSelections() {
            var removeNative = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.selectedMessages = new _set2.default();

            var selection = document.getSelection();
            if (removeNative && selection) {
                selection.removeAllRanges();
            }
        },
        addCopyListeners: function addCopyListeners() {
            var _this3 = this;

            var LogFormatter = function LogFormatter(msg) {
                var text = '';

                switch (msg.type) {
                    case 'privmsg':
                        text = '<' + msg.nick + '> ' + msg.message;
                        break;
                    case 'nick':
                    case 'mode':
                    case 'action':
                    case 'traffic':
                        text = '' + msg.message;
                        break;
                    default:
                        text = msg.message;
                }
                if (text.length) {
                    return '[' + new Date(msg.time).toLocaleTimeString({ hour: '2-digit', minute: '2-digit', second: '2-digit' }) + '] ' + text;
                }
                return null;
            };

            var copyData = '';
            var selecting = false;

            this.listen(document, 'mouseup', function (e) {
                _this3.unrestrictTextSelection();
                if (selecting) {
                    e.preventDefault();
                }
                selecting = false;
            });

            this.listen(document, 'selectionchange', function (e) {
                if (!_this3.$el) {
                    return true;
                }

                copyData = '';

                var selection = document.getSelection();

                if (!selection || !selection.anchorNode || !selection.anchorNode.parentNode.closest('.' + _this3.$el.className)) {
                    _this3.unrestrictTextSelection();
                    _this3.removeSelections();
                    return true;
                }

                _this3.removeSelections();

                _this3.restrictTextSelection();
                if (selection.rangeCount > 0) {
                    selecting = true;
                    var firstRange = selection.getRangeAt(0);
                    var lastRange = selection.getRangeAt(selection.rangeCount - 1);

                    var startNode = firstRange.startContainer.parentNode.closest('[data-message-id]');
                    var endNode = lastRange.endContainer.parentNode.closest('[data-message-id]');
                    if (!endNode) {
                        endNode = _this3.$el.querySelector('.kiwi-messagelist-item:last-child');
                    }
                    if (!startNode || !endNode || startNode === endNode) {
                        return true;
                    }

                    var node = startNode;
                    var messages = [];
                    var allMessages = _this3.buffer.getMessages();

                    var finder = function finder(m) {
                        return m.id.toString() === node.attributes['data-message-id'].value;
                    };

                    var i = 0;
                    while (node) {
                        var msg = allMessages.find(finder);

                        _this3.selectedMessages.add(msg.id);
                        if (msg) {
                            messages.push(msg);
                        }
                        if (node === endNode) {
                            node = null;
                        } else {
                            var nextNode = node.closest('[data-message-id]').parentNode.nextElementSibling;
                            node = nextNode && nextNode.querySelector('[data-message-id]');
                        }
                    }

                    _this3.selectedMessages = new _set2.default(_this3.selectedMessages);

                    copyData = messages.sort(function (a, b) {
                        return a.time > b.time ? 1 : -1;
                    }).filter(function (m) {
                        return m.message.trim().length;
                    }).map(LogFormatter).join('\r\n');
                } else {
                    _this3.unrestrictTextSelection();
                }
                return false;
            });

            this.listen(document, 'copy', function (e) {
                if (!copyData || !copyData.length) {
                    return true;
                }

                if (navigator.clipboard) {
                    navigator.clipboard.writeText(copyData);
                } else {
                    var input = document.createElement('textarea');
                    document.body.appendChild(input);
                    input.innerHTML = copyData;
                    input.select();
                    document.execCommand('copy');
                    document.body.removeChild(input);
                }
                _this3.removeSelections(true);
                return true;
            });
        },
        openEmbedInPreview: function openEmbedInPreview(message) {
            var embed = message.embed;
            if (embed.type === 'url') {
                this.$state.$emit('mediaviewer.show', embed.payload);
            } else if (embed.type === 'component') {
                this.$state.$emit('mediaviewer.show', {
                    component: embed.payload
                });
            }

            embed.payload = null;
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageList"]
window._kiwi_exports.components.MessageList = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MessageList.vue
// module id = jejM
// module chunks = 1